import React from "react";

const Bash_Echo = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Echo</h2>
      <p>Display a line of text. Common in scripts.</p>
      <h4 className="font-medium mt-4">Syntax</h4>
      <pre><code>echo [options] [string...]</code></pre>
      <h4 className="font-medium mt-4">Examples</h4>
      <pre><code>echo Hello World
echo $USER
echo "Path: $PATH"</code></pre>
      <h4 className="font-medium mt-4">Notes</h4>
      <p>Use -n to avoid trailing newline.</p>
    </div>
  );
};

export default Bash_Echo;
